import { run as runActions } from '../../../../store/workspaces/workspaces/run';

export const cardClick = (args, navData, actionsState) => {
  const eventKey = navData.widgetData?.events?.find((event) => event.type === 'onClick')?.key;
  if (eventKey) {
    runActions(eventKey, args.data.id, actionsState);
  }
  args.cancel = true;
};